import PageHero from "@/components/PageHero";
import { IMAGES, BRAND } from "@/data/content";

const SECTIONS = [
  {
    h: "1. Educational & Informational Purposes Only",
    p: "All content, materials, tools, and strategies presented on GoodLiving Solutions and its underlying company, The GoodLiving Strategy are provided strictly for educational and informational purposes. The GoodLiving Strategy is not a registered investment advisor, broker-dealer, or financial planner. Nothing on this Site constitutes personalized investment, tax, or legal advice, nor should it be construed as a recommendation to buy or sell any asset or security.",
  },
  {
    h: "2. No Guarantee of Results or Income",
    p: "We make every effort to accurately represent our programs, strategies, and their potential. However, The GoodLiving Strategy does not guarantee or promise that you will achieve any specific financial results, earn any income, or avoid financial loss. Any figures, earnings projections, or hypothetical examples displayed on the Site are estimates only and should not be considered typical, expected, or guaranteed.",
  },
  {
    h: "3. Factors Influencing Success",
    p: "Individual results depend on numerous external and personal variables outside of our control. These include, but are not limited to: your individual background, financial condition, level of skill, dedication, risk tolerance, work ethic, and broader market conditions. Engaging in financial strategies or market transactions involves inherent risk, and you may lose some or all of your invested capital.",
  },
  {
    h: "4. Testimonials and Case Studies",
    p: "Testimonials, success stories, or screenshots featured on this Site represent exceptional or non-typical individual results. They do not reflect the experience of the average user and are not intended to represent or guarantee that anyone will achieve the same or similar results.",
  },
  {
    h: "5. User Responsibility & Due Diligence",
    p: "You assume full responsibility for any financial decisions or actions you take based on the information provided on this Site. We strongly advise consulting with a licensed financial advisor, CPA, or attorney before implementing any financial strategy. By using this Site or purchasing our materials, you agree that The GoodLiving Strategy and its officers are not responsible or liable for your personal business or investment success or failure.",
  },
  {
    h: "6. Governing Law",
    p: "The GoodLiving Strategy is incorporated in the State of Wyoming, USA. These Terms & Conditions, and any dispute or claim arising out of or in connection with them or their subject matter, shall be governed by and construed in accordance with the laws of the State of Wyoming, United States of America, without regard to its conflict of law provisions.",
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHero
        eyebrow="Legal"
        title="Terms & Conditions"
        subtitle="Earnings and Risk Disclaimer — please read carefully before using this Site."
        image={IMAGES.skyline}
      />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h2 className="font-serif-display text-2xl md:text-3xl text-gl-gold mb-4 tracking-wide">
            EARNINGS AND RISK DISCLAIMER
          </h2>
          <p className="text-gl-text2/80 text-sm mb-12 leading-relaxed">
            The following terms apply to all users of {BRAND} (GoodLiving Solutions)
            and govern your access to and use of this Site and any related materials.
          </p>
          <div className="space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h3 className="font-serif-display text-2xl text-gl-text mb-3">{s.h}</h3>
                <p className="text-gl-text2 font-light leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
